/**
 * Перехватчик ошибок для голого инстанса Axios.
 *
 * До этого response-перехватчик стоял только на ApiV1, поэтому 401 на голом
 * инстансе не обрабатывался ничем: истёкшая сессия не уводила на авторизацию,
 * а прочие ошибки проходили молча. На этом инстансе работают два сервиса -
 * services/preloads и services/attestations.
 *
 * Отдаём только обработчик ошибок, без HandleAxiosResponse: тот разворачивает
 * response.data, а оба сервиса читают response.data сами - подстановка
 * сломала бы их.
 *
 * Почему отдельным файлом, а не строкой в Axios.js: AxiosHandlers тянет за
 * собой router, i18n и стор авторизации, а те - сервисы, которые импортируют
 * сами инстансы (stores/auth -> services/preloads -> Axios.js и
 * i18n -> services/lang -> ApiV1 -> Axios.js). Статический импорт
 * AxiosHandlers внутри Axios.js замкнул бы цикл на ещё вычисляющийся модуль:
 * ApiV1 вызывает BaseUrl() на верхнем уровне, до объявления этой функции дело
 * бы не дошло, и приложение падало бы на старте с ReferenceError. Этот модуль -
 * лист: его не импортирует никто, кроме main.js, поэтому новых циклов нет, а к
 * моменту выполнения тела оба инстанса уже готовы.
 */
import Axios from "@/configs/axios/Axios";
import { HandleAxiosError } from "@/configs/axios/AxiosHandlers";

Axios.interceptors.response.use(undefined, HandleAxiosError);
